import React, { PropsWithChildren, ReactElement, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Footer } from 'components/atoms/Footer';
import { FC_LICENSING_AUTH_ACCESS_TOKEN } from 'requests/auth';
import { useLocation } from 'react-router-dom';
import { config } from 'pages/config';
import { ERouteLinks, IPageBuilderConfig } from 'models/route';
import { useAuth } from 'models/authContext';
import { Navbar } from 'components/organisms/Navbar';
import { MainNavbar } from 'components/organisms/MainNavbar';
import { PageContent, PageWrapper, WizardPageContent } from './styles';

const Layout = ({ children }: PropsWithChildren<{}>): ReactElement => {
  const [isRouteNotProtected, setIsRouteNotProtected] = useState(false);

  const location = useLocation();

  const { getUser, user, isAuthenticated, setIsAuthenticated } = useAuth();

  useEffect(() => {
    setIsAuthenticated(!!localStorage.getItem(FC_LICENSING_AUTH_ACCESS_TOKEN));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem(FC_LICENSING_AUTH_ACCESS_TOKEN)]);

  useEffect(() => {
    const fetchUser = async () => {
      if (user === null) {
        await getUser();
      }
    };
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    setIsRouteNotProtected(
      config.find((route: IPageBuilderConfig) => route.route === location.pathname)
        ?.isProtected === false,
    );
  }, [isAuthenticated, location]);

  document.addEventListener(
    'itemInserted',
    () => {
      if (localStorage.getItem(FC_LICENSING_AUTH_ACCESS_TOKEN)) {
        setIsAuthenticated(true);
      }
    },
    false,
  );

  document.addEventListener(
    'itemRemoved',
    () => {
      if (localStorage.getItem(FC_LICENSING_AUTH_ACCESS_TOKEN) && user) {
        setIsAuthenticated(false);
      }
    },
    false,
  );

  const isApplyOnlineWizard = location.pathname.startsWith(ERouteLinks.ApplyOnlineWizard);

  if (isApplyOnlineWizard) {
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
        {isAuthenticated && !isRouteNotProtected ? (
          <Box component="main" sx={{ flexGrow: 1 }}>
            <WizardPageContent>{children}</WizardPageContent>
          </Box>
        ) : (
          <>
            <Navbar />
            <Box component="main" sx={{ flexGrow: 1 }}>
              <PageContent>
                <PageWrapper>{children}</PageWrapper>
              </PageContent>
              <Footer />
            </Box>
          </>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
      {isAuthenticated && !isRouteNotProtected ? (
        <>
          <MainNavbar />
          <Box component="main" sx={{ flexGrow: 1 }}>
            <PageContent>
              <PageWrapper>{children}</PageWrapper>
            </PageContent>
            <Footer />
          </Box>
        </>
      ) : (
        <>
          <Navbar />
          <Box component="main" sx={{ flexGrow: 1 }}>
            <PageContent>
              <PageWrapper>{children}</PageWrapper>
            </PageContent>
            <Footer />
          </Box>
        </>
      )}
    </Box>
  );
};

export { Layout };
